import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { I18nModule } from '@recruitee/i18n';

import { TooltipModule } from '../tooltip/tooltip.module';
import { TimeAgoAsyncPipe } from './pipes/time-ago-async.pipe';
import { TimeAgoPipe } from './pipes/timeago.pipe';
import { DateComponent } from './rt-date/date.component';

@NgModule({
  imports: [CommonModule, TooltipModule, MomentModule, I18nModule],
  declarations: [TimeAgoAsyncPipe, TimeAgoPipe, DateComponent],
  exports: [DateComponent, TimeAgoAsyncPipe, TimeAgoPipe, MomentModule],
})
export class DateModule {}

export { TimeAgoAsyncPipe } from './pipes/time-ago-async.pipe';
export { TimeAgoBase } from './pipes/timeago';
export { TimeAgoPipe } from './pipes/timeago.pipe';
export { DateComponent } from './rt-date/date.component';
